"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var axios_1 = __importDefault(require("axios"));
var microsoft_graph_client_1 = require("@microsoft/microsoft-graph-client");
require("isomorphic-fetch"); // Polyfill required if you are using microsoft-graph-client
var cacheService = __importStar(require("./../services/cacheService"));
var client;
exports.initialize = function (tenantName, clientId, clientSecret) {
    var clientOptions = {
        authProvider: new MyAuthenticationProvider(tenantName, clientId, clientSecret, "https://graph.microsoft.com/"),
    };
    client = microsoft_graph_client_1.Client.initWithMiddleware(clientOptions);
};
var MyAuthenticationProvider = /** @class */ (function () {
    function MyAuthenticationProvider(tenantId, clientId, clientSecret, resource) {
        this.tenantId = tenantId;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.resource = resource;
    }
    /**
     * This method will get called before every request to the msgraph server
     * This should return a Promise that resolves to an accessToken (in case of success) or rejects with error (in case of failure)
     * Basically this method will contain the implementation for getting and refreshing accessTokens
     */
    MyAuthenticationProvider.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cachedToken, url, postData, options, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedToken = cacheService.getCachedAccessToken(cacheService.msGraphAccessTokenKey);
                        if (cachedToken)
                            return [2 /*return*/, cachedToken];
                        url = "https://login.microsoftonline.com/" + this.tenantId + "/oauth2/token";
                        postData = querystring_1.default.stringify({
                            client_id: this.clientId,
                            client_secret: this.clientSecret,
                            resource: this.resource,
                            grant_type: "client_credentials",
                        });
                        options = {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Content-Length": postData.length,
                            },
                        };
                        console.log("Getting new Microsoft Graph API access token");
                        return [4 /*yield*/, axios_1.default.post(url, postData, options)];
                    case 1:
                        response = _a.sent();
                        // expires_in  ==> How long the access token is valid (in seconds).
                        cacheService.cacheAccessToken(cacheService.msGraphAccessTokenKey, response.data.access_token, response.data.expires_in);
                        return [2 /*return*/, response.data.access_token];
                }
            });
        });
    };
    return MyAuthenticationProvider;
}());
exports.getMembersOfSecurityGroup = function (groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, client.api("/groups/" + groupId + "/members").get()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.value];
        }
    });
}); };
exports.getMemberGroups = function (userOid) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, client
                    .api("/users/" + userOid + "/getMemberGroups")
                    .post({ securityEnabledOnly: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.value];
        }
    });
}); };
exports.getUserByEmail = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, client.api("/users/" + email).get()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
